<template>
    <audio
        ref="audio"
        :src="cheering"
        @canplaythrough="disabled = false"
        @ended="disabled = false"
    />
</template>

<script>
import { showConfetti } from "~/lib/confetti"
import cheering from "~/sounds/cheer.mp3"
import { useListenerManager } from "front-toolkit/plugins/ListenersPlugin"

export default {
    setup() {
        const { listen } = useListenerManager()
        return { listen, cheering }
    },

    data() {
        return {
            disabled: true,
        }
    },

    mounted() {
        this.listen("keydown", event => {
            const { altKey, key } = event
            if (!altKey) return
            if (key.toLowerCase() === "c") {
                this.celebrate()
            }
        })
    },

    methods: {
        celebrate() {
            if (this.disabled) return
            this.disabled = true
            showConfetti([
                "#fff",
                this.$store.state.theme.customization.primaryColor,
            ])
            this.$refs.audio.play()
        },
    },
}
</script>
